import { useState } from "react";

import { useToasts } from "react-toast-notifications";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { PrimaryButton, SecondaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

import { useSalesSavedViews } from "../sales-saved-views-provider";
import { useSalesPageV3NextContext } from "../sales-v3-next-provider";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UpdateSavedViewsModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: Props) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { addToast } = useToasts();
  const { updateSavedView } = useSalesSavedViews();
  const { selectedSavedView, pageConfiguration, chartState, tableState } =
    useSalesPageV3NextContext();

  const [isSaving, setIsSaving] = useState(false);

  const saveSavedView = async () => {
    prettyLogEventPage({
      domain: "Top Level Filters",
      action: "onChange",
      additionalActionInfo: "Update Saved View",
    });

    try {
      setIsSaving(true);
      await updateSavedView({
        id: selectedSavedView.id,
        config: {
          pageConfiguration,
          chartState,
          tableState,
        },
      });
      onConfirm();
      addToast("Saved view updated", { appearance: "success" });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      headerTitleProps={{ className: "text-xl font-semibold" }}
      titleContent={
        <div>Overwrite current view for all users on your account?</div>
      }
    >
      <p className="text-sm mb-8 text-[#717680]">Changes cannot be undone</p>
      <div className="flex space-x-3">
        <PrimaryButton loading={isSaving} onClick={saveSavedView}>
          YES, SAVE
        </PrimaryButton>
        <SecondaryButton disabled={isSaving} onClick={onCancel}>
          NO, CANCEL
        </SecondaryButton>
      </div>
    </Modal>
  );
};
